// extracted by mini-css-extract-plugin
export default {"logInButton":"logInButton--2WGyA"};